<div class="customer-menu-item">
    <a class="menu-link" [title]="menuItem.title" [id]="menuItem.routerLink" (click)="swapTenant(menuItem.routerLink)">
        <mat-icon>{{menuItem.menuIcon}}</mat-icon>
        <span>{{menuItem.title}}</span>
    </a>
</div>
